export const AUTH_SET_SESSION = "AUTH_SET_SESSION";
export const AUTH_LOGOUT = "AUTH_LOGOUT";
export const AUTH_UPDATE_USER = "AUTH_UPDATE_USER";
export const AUTH_SET_ONBOARDING = "AUTH_SET_ONBOARDING";
